const i18nKeyPrefix: string = 'STAFF-DOWNLOAD-APP'
export { default } from './StaffDownloadApp'
export { i18nKeyPrefix }
